import React from 'react';
import { Routes, Route } from 'react-router-dom';
import './i18n'; // Import i18n configuration
// Import page components here once they are created
import HomePage from './pages/HomePage';
import ServicesPage from './pages/ServicesPage';
import ServiceDetailPage from './pages/ServiceDetailPage';
import AboutPage from './pages/AboutPage';
import TestimonialsPage from './pages/TestimonialsPage';
import ContactUsPage from './pages/ContactUsPage';
import BlogPage from './pages/BlogPage';
import BlogPostPage from './pages/BlogPostPage';
// import ContactPage from './pages/ContactPage';
// import BlogListPage from './pages/BlogListPage';
// import NotFoundPage from './pages/NotFoundPage';

// Import auth pages
import LoginPage from './pages/auth/LoginPage';
import RegisterPage from './pages/auth/RegisterPage';
import UserManagementPage from './pages/admin/UserManagementPage';
import CustomersPage from './pages/admin/CustomersPage';
import AdminServiceRequestsPage from './pages/admin/AdminServiceRequestsPage';
import ServiceRequestsManagementPage from './pages/admin/ServiceRequestsManagementPage';
import AdminServiceRequestDetailPage from './pages/admin/AdminServiceRequestDetailPage';
import EstimatesPage from './pages/admin/EstimatesPage';
import QuotesPage from './pages/admin/QuotesPage';
import InvoicesPage from './pages/admin/InvoicesPage';
import CreateEstimatePage from './pages/admin/CreateEstimatePage';
import ViewEstimatePage from './pages/admin/ViewEstimatePage';
import EditEstimatePage from './pages/admin/EditEstimatePage';
import NewQuotePage from './pages/admin/NewQuotePage';
import ViewQuotePage from './pages/admin/ViewQuotePage';
import EditQuotePage from './pages/admin/EditQuotePage';
import NewInvoicePage from './pages/admin/NewInvoicePage';
import ViewInvoicePage from './pages/admin/ViewInvoicePage';
import EditInvoicePage from './pages/admin/EditInvoicePage';
import ExpensesPage from './pages/admin/ExpensesPage';
import CreateExpensePage from './pages/admin/CreateExpensePage';
import ViewExpensePage from './pages/admin/ViewExpensePage';
import EditExpensePage from './pages/admin/EditExpensePage';
import TaxReportingPage from './pages/admin/TaxReportingPage';
import InventoryPage from './pages/admin/InventoryPage';
import InventoryFormPage from './pages/admin/InventoryFormPage';
import InventoryDetailPage from './pages/admin/InventoryDetailPage';
import ProfileSettingsPage from './pages/user/ProfileSettingsPage';
import MyServiceRequestsPage from './pages/user/MyServiceRequestsPage';
import PInvoicesPage from './pages/PInvoicesPage';

// Import layout components
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import EmergencyCallout from './components/layout/EmergencyCallout';
import { useModal } from './contexts/ModalContext';
import ScheduleServiceModal from './components/modals/ScheduleServiceModal';

// Main App component to house the modal logic
function App() {
  const { isModalOpen, closeModal, modalType } = useModal();

  return (
    <div className="flex flex-col min-h-screen font-sans bg-brand-background-light text-brand-text-dark">
      <EmergencyCallout />
      <Header />
      <main className="flex-grow py-8 overflow-y-auto">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/services/:serviceSlug" element={<ServiceDetailPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/testimonials" element={<TestimonialsPage />} />
          <Route path="/contact" element={<ContactUsPage />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/blog/:slug" element={<BlogPostPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/admin/users" element={<UserManagementPage />} />
          <Route path="/admin/customers" element={<CustomersPage />} />
          <Route path="/admin/service-requests" element={<AdminServiceRequestsPage />} />
          <Route path="/admin/service-requests-management" element={<ServiceRequestsManagementPage />} />
          <Route path="/admin/service-requests/:id" element={<AdminServiceRequestDetailPage />} />
          <Route path="/admin/estimates" element={<EstimatesPage />} />
          <Route path="/admin/estimates/new" element={<CreateEstimatePage />} />
          <Route path="/admin/estimates/view/:estimateId" element={<ViewEstimatePage />} />
          <Route path="/admin/estimates/edit/:estimateId" element={<EditEstimatePage />} />
          <Route path="/admin/quotes" element={<QuotesPage />} />
          <Route path="/admin/quotes/new" element={<NewQuotePage />} />
          <Route path="/admin/quotes/view/:quoteId" element={<ViewQuotePage />} />
          <Route path="/admin/quotes/edit/:quoteId" element={<EditQuotePage />} />
          <Route path="/admin/invoices" element={<InvoicesPage />} />
          <Route path="/admin/invoices/new" element={<NewInvoicePage />} />
          <Route path="/admin/invoices/view/:invoiceId" element={<ViewInvoicePage />} />
          <Route path="/admin/invoices/edit/:invoiceId" element={<EditInvoicePage />} />
          <Route path="/admin/expenses" element={<ExpensesPage />} />
          <Route path="/admin/expenses/new" element={<CreateExpensePage />} />
          <Route path="/admin/expenses/view/:expenseId" element={<ViewExpensePage />} />
          <Route path="/admin/expenses/edit/:expenseId" element={<EditExpensePage />} />
          <Route path="/admin/tax-reporting" element={<TaxReportingPage />} />
          <Route path="/admin/inventory" element={<InventoryPage />} />
          <Route path="/admin/inventory/new" element={<InventoryFormPage />} />
          <Route path="/admin/inventory/:id" element={<InventoryDetailPage />} />
          <Route path="/admin/inventory/:id/edit" element={<InventoryFormPage />} />
          <Route path="/profile-settings" element={<ProfileSettingsPage />} />
          <Route path="/my-service-requests" element={<MyServiceRequestsPage />} />
          <Route path="/pinvoices" element={<PInvoicesPage />} />
          {/* <Route path="/contact" element={<ContactPage />} /> */}
          {/* <Route path="/testimonials" element={<TestimonialsPage />} /> */}
          {/* <Route path="/privacy-policy" element={<PrivacyPolicyPage />} /> */}
          {/* <Route path="/terms-of-service" element={<TermsOfServicePage />} /> */}
          {/* <Route path="*" element={<NotFoundPage />} /> */}
        </Routes>
      </main>
      <Footer />
      <ScheduleServiceModal 
        isOpen={isModalOpen && (modalType === 'scheduleService' || modalType === 'getEstimate')} 
        onClose={closeModal} 
      />
    </div>
  );
}

export default App; 